import { render, staticRenderFns } from "./__ProductModal.vue?vue&type=template&id=70dc63fc&"
import script from "./__ProductModal.vue?vue&type=script&lang=js&"
export * from "./__ProductModal.vue?vue&type=script&lang=js&"
import style0 from "./__ProductModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports